export default __webpack_public_path__ + "static/media/minimize.c79f0fa7.svg";